@if (items().length) {
  <div class="ms-large-b">
    <h2 class="mr-small-b">{{ content().teaserTitle }}</h2>
    <div class="descriptive-link-list flex flex--align-start flex--wrap flex--space-between">
      @for (item of items(); track item.contentId) {
        <div class="descriptive-link-item mr-small-b">
          <h3 class="descriptive-link-title nordic-blue-900-text text-icon-primary font-title-small">
            {{ item.teaserTitle }}
          </h3>
          <div class="descriptive-link-text ms-small-y" [innerHTML]="item.teaserText"></div>
          @if (item.target && item.linkText) {
            <div class="font-body-medium-bold">
              <a
                [finLink]="item.target.url"
                [external]="item.target.external"
                [attr.target]="item.target.openInNewTab ? '_blank' : ''"
                class="descriptive-link no-decoration nordic-blue-900-text text-icon-primary"
              >
                <span
                  >{{ item.linkText }}
                  <fcom-icon
                    class="arrow-icon nordic-blue-900-text text-icon-primary icon-small ms-xxsmall-l"
                    [name]="SvgLibraryIcon.ARROW_RIGHT"
                  />
                </span>
              </a>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
